import {
  faPlay,
  faPlus,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faCheck,
  faDownload,
  faUpload,
  faWrench,
  faTrash,
  faExclamation,
  faTimes,
  faClock,
  faSearch,
  faPaperPlane,
  faPhoneAlt,
  faCog,
  faUser,
  faFilePdf,
  faInfoCircle,
  faExternalLinkAlt,
  faPen,
  faPlusCircle,
  faGraduationCap,
  faBook,
  faProjectDiagram,
  faRulerCombined,
  faPause,
  faTimesCircle,
  faComments,
  faTools,
  faWifi,
  faStar,
  faBell,
  faRedo,
  faSortDown,
  faSortUp,
  faExclamationTriangle,
  faMapMarkerAlt,
  faFilter,
  faTachometerAlt,
  faStepBackward,
  faGlobeAmericas,
  faKey,
  faCodeBranch,
  faSpinner
} from '@fortawesome/free-solid-svg-icons'

import {faThumbsUp as fasThumbsUp} from '@fortawesome/free-solid-svg-icons'
import {faThumbsDown as fasThumbsDown} from '@fortawesome/free-solid-svg-icons'
import {faQuestionCircle as fasQuestionCircle} from '@fortawesome/free-solid-svg-icons'

export default {
  faPlay,
  faPlus,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faCheck,
  faDownload,
  faUpload,
  faWrench,
  faTrash,
  faExclamation,
  faTimes,
  faClock,
  faSearch,
  faPaperPlane,
  faPhoneAlt,
  faCog,
  faUser,
  faFilePdf,
  faInfoCircle,
  faExternalLinkAlt,
  faPen,
  faGraduationCap,
  faBook,
  faProjectDiagram,
  faRulerCombined,
  faPause,
  faTimesCircle,
  fasThumbsUp,
  fasThumbsDown,
  faComments,
  faTools,
  faWifi,
  faStar,
  faBell,
  faRedo,
  faSortDown,
  faSortUp,
  faExclamationTriangle,
  faMapMarkerAlt,
  faPlusCircle,
  faFilter,
  faTachometerAlt,
  faStepBackward,
  fasQuestionCircle,
  faGlobeAmericas,
  faKey,
  faCodeBranch,
  faSpinner
}
